import React, { useCallback, useMemo, useState } from 'react'
import { faCloudArrowDown, faEdit, faEye, faTimes, faTrashCan } from '@fortawesome/pro-light-svg-icons'
import { getCountryNameById, getDictionaryStates } from '../../../../utils/globals/countries'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import TwinIcon, { TwinIconProp, TwinIconToolTip } from '../../../TwinIcon'
import { RowData } from '../../types'
import { ParameterValueType } from '../Subcomponents/types'
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-light-svg-icons'
import { displayDate, displayDateHours, displayDateTime, displayFormatedHourFromMins, displayFormatedHourFromSecs, displayFormatedHourMinSec, displayFormatedMinsFromSecs, getHoursMinSecFromSecs} from '../../../../utils/globals/date'
import { getAllLangs } from '../../../../utils/reducers/getters'
import { nanoid } from 'nanoid'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import TwinToolTip, { TwinToolTipWhite } from '../../../TwinToolTip'
import { getAllCurrencies } from '../../../../utils/reducers/getters'
import DisplayPrice from '../../../Displays/DisplayPrice'
import { getCurrencySymbol } from '../../../../utils/globals/price'
import { ModalOpenedTy } from '../../../Modal/types'
import { ModalBigCenteredOutside } from '../../../Modal'

interface CustomRenderCountryNameProps {
    countryId: ParameterValueType
}

export const CustomRenderCountryName: React.FC<CustomRenderCountryNameProps> = ({ countryId }) => {
    const countryName = getCountryNameById(countryId)
    return (
        <div>
            {countryName?.name}
        </div>
    )
}

interface CustomRenderLanguageNameProps {
    languageId: ParameterValueType
}

export const CustomRenderLanguageName: React.FC<CustomRenderLanguageNameProps> = ({ languageId }) => {
    const languageName = getAllLangs()[languageId]?.name
    return (
        <div>
            {languageName}
        </div>
    )
}

interface CustomRenderStateNameProps {
    stateId: ParameterValueType
    allRowData: RowData
}

export const CustomRenderStateName: React.FC<CustomRenderStateNameProps> = ({ stateId, allRowData }) => {
    const states = getDictionaryStates(allRowData.country)
    const stateName = states[stateId]?.name
    return (
        <div>
            {stateName}
        </div>
    )
}
interface CustomRenderBooleanProps {
    value: boolean
    width?: number
    onClick?: () => void
    className?: string
}

export const CustomRenderBoolean: React.FC<CustomRenderBooleanProps> = ({ value, width, onClick, className }) => {
    let renderThis = <TwinIcon icon={faTimesCircle} className='text-red-BA' size='lg' />
    if (value) {
        renderThis = <TwinIcon icon={faCheckCircle} className='text-green-43' size='lg' />
    }
    return (
        <div className={'flex items-center w-full custom_render_boolean ' + (className|| '')} onClick={onClick}>
            <div className='text-center' style={{width: width ?? '100%'}}>
                {renderThis}
            </div>
        </div>
    )
}

interface CustomRenderBooleanTextProps {
    value: boolean
    width?: number
    title: {
        on: string
        off: string
    }
    className?: string
    onClick?: () => void
}

export const CustomRenderBooleanText: React.FC<CustomRenderBooleanTextProps> = ({ title, value, width, className,  onClick }) => {
    let myClassName = ' border-red-BA text-red-BA '
    let text = title['off']
    if (value) {
        myClassName = 'border-green-43 text-green-43 '
        text = title['on']
    }
    return (
        <div className='flex items-center w-full custom_render_boolean' onClick={onClick} style={{width: width ?? '100%'}}>
            <div className={'border rounded-5 px-10 py-1 text-center mx-auto ' + myClassName + (className || '')} >
                {text}
            </div>
        </div>
    )
}

interface CustomRenderDateProps {
    value: string
    className?: string
}

export const CustomRenderDate: React.FC<CustomRenderDateProps> = ({ value, className }) => {
    const renderThis = value ? displayDate(new Date(value)) : ''
    return (
        <div className={'flex items-center w-full custom_render_date ' + (className || '')}>
            {renderThis}
        </div>
    )
}

interface CustomRenderDateHoursProps {
    value: string
}

export const CustomRenderDateHours: React.FC<CustomRenderDateHoursProps> = ({ value }) => {
    const renderThis = value ? displayDateTime(new Date(value)) : ''
    return (
        <div className='flex items-center w-full custom_render_date twin_elipsis'>
            {renderThis}
        </div>
    )
}
interface CustomRenderDateJustHoursProps {
    value: string
}

export const CustomRenderDateJustHours: React.FC<CustomRenderDateJustHoursProps> = ({ value }) => {
    const renderThis = value ? displayDateHours(new Date(value)) : ''
    return (
        <div className='flex items-center w-full custom_render_date'>
            {renderThis}
        </div>
    )
}

interface CustomRenderTimeProps {
    value: string
}

export const CustomRenderTime: React.FC<CustomRenderTimeProps> = ({ value }) => {
    const hoursMinSecs = getHoursMinSecFromSecs(parseInt(value))
    const renderThis = displayFormatedHourMinSec(hoursMinSecs)
    return (
        <div className='twin_elipsis_table_two_lines'>
            {renderThis}
        </div>
    )
}

interface CustomRenderStringProps {
    value: string
    className?: string
}

export const CustomRenderString: React.FC<CustomRenderStringProps> = ({ value, className }) => {
    return (
        <div className={'twin_elipsis_table_two_lines ' + (className || '')}>
            {value}
        </div>
    )
}

interface CustomRenderStringTwoLinesTooltipProps extends CustomRenderStringProps {
    id: string
}

export const CustomRenderStringTwoLinesTooltip: React.FC<CustomRenderStringTwoLinesTooltipProps> = ({ id, value, className }) => {
    return (
        <div data-tooltip-id={id} className={'twin_two_lines_elipsis ' + (className || '')}>
            <TwinToolTip id={id} content={value} className='max-w-300' />
            {value}
        </div>
    )
}

interface CustomRenderStringAndColorProps {
    value: string
    color: string
    className?: string
}

export const CustomRenderStringAndColor: React.FC<CustomRenderStringAndColorProps> = ({ value, color, className }) => {
    return (
        <div className={'flex items-center flex-auto w-1 ' + (className || '')}>
            <div className={'rounded-full h-10 min-w-10 mr-10 border border-gray-D6 '} style={{ backgroundColor: color }} />
            <div className='flex-auto twin_elipsis'>{value}</div>
        </div>
    )
}

interface CustomRenderStringAndColorNullProps {
    value?: string
    color?: string
    className?: string
}

export const CustomRenderStringAndColorNull: React.FC<CustomRenderStringAndColorNullProps> = ({ value, color, className }) => {
    if (!value) {
        return null
    }
    return (
        <CustomRenderStringAndColor className={className} value={value} color={color || ''} />
    )
}

interface CustomRenderImageProps {
    value: string
}

export const CustomRenderImage: React.FC<CustomRenderImageProps> = ({ value }) => {
    return (
        <img src={value} className={'custom_render_image'} alt=''/>
    )
}

export interface CustomRenderImageToolTipProps {
    value: string
    allRowData: RowData
    className?: string
}

export const CustomRenderImageToolTip: React.FC<CustomRenderImageToolTipProps> = ({ value, allRowData, className }) => {
    const myValue = value && value.length ? value : ''
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    if (!myValue) {
        return null
    }
    return (
        <div className={'table_displayimg_parent ' + (className || '')}>
            <TwinToolTipWhite id={'table_' + allRowData?.id} place='top' >
                <img src={myValue} className='max-h-200 max-w-200 p-5' alt='' />
            </TwinToolTipWhite>
            <img src={myValue} className='table_displayimg cursor-pointer object-cover h-full w-full' alt='' data-tooltip-id={'table_' + allRowData?.id} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpened(true) }} />
            {opened ? <ModalBigCenteredOutside opened={opened} setOpened={setOpened} className='overflow-hidden'>
                <TwinIcon icon={faTimes} fontSize={20} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpened(null) }} className='top-2 right-4 absolute cursor-pointer' />
                <img src={myValue} className='w-full h-full object-contain' alt='' />
            </ModalBigCenteredOutside> : null}
        </div>
    )
}

interface CustomRenderPriceProps {
    value: ParameterValueType
    allRowData: RowData
}

export const CustomRenderPrice: React.FC<CustomRenderPriceProps> = ({ value, allRowData }) => {
    const CurrencySymbol = getCurrencySymbol(allRowData?.CurrencyId || 'EUR')
    return (
        <div>
            {value}
            <span className='ml-5'>
                {CurrencySymbol}
            </span>
        </div>
    )
}

interface CustomRenderColorProps {
    value: string
    className?: string
}

export const CustomRenderColor: React.FC<CustomRenderColorProps> = ({ value, className }) => {
    return (
        <div className={'rounded-full h-20 w-20 mr-10 border border-gray-D6 ' + (className || '')} style={{ backgroundColor: value }} />
    )
}

interface CustomRenderIconProps {
    icon: TwinIconProp
    className?: string
}

export const CustomRenderIcon: React.FC<CustomRenderIconProps> = ({ icon, className }) => {
    return (
        <div className={'h-20 w-20 mr-10 ' + (className || '')}>
            <TwinIcon icon={icon} className='w-20 h-20'/>
        </div>
    )
}

interface CustomRenderDisplayHoursByMinsProps {
    value: string
    className?: string
}

export const CustomRenderDisplayHoursByMins: React.FC<CustomRenderDisplayHoursByMinsProps> = ({ value, className }) => {
    return (
        <span className={className}>{displayFormatedHourFromMins(parseInt(value))}</span>
    )
}
interface CustomRenderDisplayMinsBySecsProps {
    value: string
    className?: string
}

export const CustomRenderDisplayMinsBySecs: React.FC<CustomRenderDisplayMinsBySecsProps> = ({ value, className }) => {
    return (
        <span className={className}>{displayFormatedMinsFromSecs(parseInt(value))}</span>
    )
}

interface CustomRenderDisplayHoursMinsSecsBySecsProps {
    value: number
    className?: string
}

export const CustomRenderDisplayHoursMinsSecsBySecs: React.FC<CustomRenderDisplayHoursMinsSecsBySecsProps> = ({ value, className }) => {
    return (
        <span className={className}>{displayFormatedHourFromSecs(value)}</span>
    )
}

interface CustomRenderProfileImageProps {
    value: string
    name?: string
}

export const CustomRenderProfileImage: React.FC<CustomRenderProfileImageProps> = ({ value, name }) => {
    return (
        <img src={value} className={'custom_render_image'} alt={name} />
    )
}

export interface CustomRenderRoundedImageProps {
    img?: string
    name?: string
    className?: string
    icon: TwinIconProp
}

export const CustomRenderRoundedImage: React.FC<CustomRenderRoundedImageProps> = ({ name, img, className, icon }) => {
    const idTooltip = useMemo(() => 'Tooltip_CustomRenderRoundedImage' + nanoid(), [])
    const {t} = useTwinTranslation()
    const notSelected = t('notSelected', 'No seleccionado')
    return (
        <div className={' text-gray-63 border rounded-full overflow-hidden items-center justify-center flex ' + (!img ? 'border-gray-C7 ':' border-none ') + (className || '')} >
            <TwinToolTip id={idTooltip} place='top' content={name || notSelected} />
            {img ? <img data-tooltip-id={idTooltip} src={img} alt={name} className='w-full h-full object-cover rounded-full' /> : <TwinIcon data-tooltip-id={idTooltip} icon={icon} />}
        </div>
    )
}

interface DefaultTableCustomRenderProps {
    items: TwinDictionary
    value: string | string[]
    fieldName?: string
}

export const DefaultTableCustomRender: React.FC<DefaultTableCustomRenderProps> = ({ items, value, fieldName='name' }) => {
    let renderThis: string
    if (Array.isArray(value)) {
        let stringArr: any = []
        for (const element of value) {
               stringArr.push(items[element]?.[fieldName])
        }
        renderThis = stringArr.join(', ')
    } else {
        renderThis = items[value]?.[fieldName]
    }
    return (
        <div className='twin_elipsis_table_two_lines'>
            {renderThis}
        </div>
    )
}

type EditRowClick = (parameterValue: ParameterValueType, allRowData: RowData, e: React.MouseEvent) => void
interface EditRowProps {
    parameterValue: ParameterValueType
    allRowData: RowData
    onClick?: EditRowClick
    icon?: TwinIconProp
    className?: string
    messageTooltip?: string
}
export const EditRow: React.FC<EditRowProps> = ({ icon = faEdit, messageTooltip, className, ...rest }) => {
    const {t} = useTwinTranslation()
    const { handleEdit } = useEditRowLogic(rest)
    return (
        <div className={'flex justify-center items-center ' + (className || '')} onClick={handleEdit}>
            <TwinIconToolTip icon={icon} className='cursor-pointer hover:text-green-43' classNameIcon='fa-lg' message={messageTooltip || t('edit', 'Editar')} id={(rest?.allRowData?.rowIndex || '') + 'editRow'} />
        </div>
    )
}

const useEditRowLogic = ({ parameterValue, allRowData, onClick }: EditRowProps) => {
    const handleEdit = useCallback((e: React.MouseEvent) => {
        onClick?.(parameterValue, allRowData, e)
    }, [onClick, parameterValue, allRowData])

    return { handleEdit }
}

export const EditRowNotLink: React.FC<EditRowProps> = ({ onClick, ...rest }) => {
    const { handleEdit } = useEditRowNotLink({ onClick, ...rest })
    return <EditRow onClick={handleEdit} {...rest}></EditRow>
}
const useEditRowNotLink = ({ onClick }: EditRowProps) => {
    const handleEdit = useCallback<EditRowClick>((parameterValue, allRowData, e) => {
        e.preventDefault()
        e.stopPropagation()
        onClick?.(parameterValue, allRowData, e)
    }, [onClick])

    return { handleEdit }
}
export interface ShowRowProps extends EditRowProps { }

export const ShowRow: React.FC<ShowRowProps> = ({icon, className,  messageTooltip, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleShow } = useShowRowLogic(rest)
    return (
        <div className={'flex justify-center items-center ' + (className || '')} onClick={handleShow}>
            <TwinIconToolTip icon={icon || faEye} className='cursor-pointer hover:text-green-43' classNameIcon='fa-lg' message={messageTooltip || t('see', 'Ver')} id={(rest?.allRowData?.rowIndex || '') + 'showRow'} />
        </div>
    )
}

export const useShowRowLogic = ({ parameterValue, allRowData, onClick }: DeleteRowProps) => {
    const handleShow = useCallback((e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        onClick?.(parameterValue, allRowData, e)
    }, [onClick, parameterValue, allRowData])

    return { handleShow }
}
export interface DeleteRowProps extends EditRowProps { }

export const DeleteRow: React.FC<DeleteRowProps> = ({icon, className,  messageTooltip, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleDelete } = useDeleteRowLogic(rest)
    return (
        <div className={'flex justify-center items-center delete_row ' + (className || '')} onClick={handleDelete}>
            <TwinIconToolTip icon={icon || faTrashCan} className='cursor-pointer hover:text-red-BA' classNameIcon='fa-lg' message={messageTooltip || t('delete', 'Eliminar')} id={(rest?.allRowData?.rowIndex || '') + 'deleteRow'} />
        </div>
    )
}

export const useDeleteRowLogic = ({ parameterValue, allRowData, onClick }: DeleteRowProps) => {
    const handleDelete = useCallback((e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        onClick?.(parameterValue, allRowData, e)
    }, [onClick, parameterValue, allRowData])

    return { handleDelete }
}

interface CustomRenderCurrencyNameProps {
    currencyId: ParameterValueType
}

export const CustomRenderCurrencyName: React.FC<CustomRenderCurrencyNameProps> = ({ currencyId }) => {
    const currencyName = getAllCurrencies()[currencyId]
    return (
        <div>
            {currencyName.name}
        </div>
    )
}

interface CustomRenderDownloadFileProps {
    url: string
}

export const CustomRenderDownloadFile: React.FC<CustomRenderDownloadFileProps> = ({ url }) => {
    if (!url) {
        return null
    } else {
        return (
            <a href={url} target='_blank' rel="noreferrer">
                <TwinIcon icon={faCloudArrowDown} className='cursor-pointer hover:text-green-43' size='lg' />
            </a>
        )
    }
}

interface CustomRenderDisplayPriceWOParamsProps {
    value: string
    CurrencyId: string
}

export const CustomRenderDisplayPriceWOParams: React.FC<CustomRenderDisplayPriceWOParamsProps> = ({ value, CurrencyId }) => {
    return (
        <DisplayPrice value={parseFloat(value)} CurrencyId={CurrencyId} with_vat={false} calculateParams={{
            decimals: 2,
            rounding: '0.01',
            roundingPriceType: 'medium'
        }} />
    )
}
